import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';

@Component({
    selector   : 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls  : ['./confirm-dialog.component.scss']
})
export class FuseConfirmDialogComponent
{
    public message: string;
    public title: string;

    constructor(public dialogRef: MatDialogRef<FuseConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
        this.title = data.title;
        this.message = data.message;
    }    

}

export class ConfirmDialogModel {

  constructor(public title: string, public message: string) {
  }
}
